import AbstractCarousel from '../Carousel';
import { generateImageObserverCallback, generateImageObserverOptions } from './Utils';
import { generateVideoObserverCallback, generateVideoObserverOptions } from '../ProductCardVideo/utils';

class ProductCardMediaGallery extends AbstractCarousel {
  constructor({ gallery, prefixClassName, gap, features, extraToggleClass }) {
    super({ gallery, prefixClassName, gap, features, extraToggleClass });
  }

  /**
   * Initialize Product Card Media Gallery
   */
  init() {
    // Bind all basic events
    this.bindAbstractCarouselEvents();
    //
    this.setImages();
    // Bind its own events
    this.#setObservers();
  }

  setImages() {
    this.images = this.carousel.querySelectorAll(
      '.product-card-c-gallery__list-item.product-card-c-gallery__list-item--image',
    );
    this.videos = this.carousel.querySelectorAll(
      '.product-card-c-gallery__list-item.product-card-c-gallery__list-item--video',
    );
  }

  #setObservers() {
    // Injects an observer for fetching image media whenever are visible by target
    const imageObserverCallback = generateImageObserverCallback();
    const imageObserverOptions = generateImageObserverOptions(this.carousel);
    this.images.forEach((imageItem) => {
      const observer = new IntersectionObserver(imageObserverCallback, imageObserverOptions);
      observer.observe(imageItem);
    });

    const videoObserverCallback = generateVideoObserverCallback();
    this.videos.forEach((videoItem, index) => {
      let videoObserverOptions = generateVideoObserverOptions(this.carousel);
      // For the first video element, we want to load it as soon as it becomes visible in the viewport,
      // For subsequent video elements, we want to load them when they are about to come into view in the carousel.
      if (index === 0) {
        videoObserverOptions = generateImageObserverOptions(null);
      } else {
        videoObserverOptions = generateVideoObserverOptions(this.carousel);
      }
      const observer = new IntersectionObserver(videoObserverCallback, videoObserverOptions);
      observer.observe(videoItem);
    });
  }

  resetPosition() {
    this.carousel.scrollTo({ left: 0 });
  }

  close() {
    this.closeAbstractCarouselEvents();
  }
}

export default ProductCardMediaGallery;
